import { ActionIcon, Box, Menu } from '@mantine/core';
import { IconDotsVertical, IconEdit, IconTrash, IconUserShare } from '@tabler/icons-react';
import { useState } from 'react';
import useCurrentUser from 'src/admin/users/hooks/useCurrentUser';
import TransferFamilyModal from 'src/clients/components/TransferFamilyModal';

type FamilyActionTarget = {
  id: string;
  name: string;
  advisorUserId?: string;
};

type Props = {
  family: FamilyActionTarget;
  onEdit: () => void;
  onDelete: () => void;
  iconSize?: number;
  iconColor?: string;
};

export function FamilyActionsMenu({ family, onEdit, onDelete, iconSize = 20, iconColor }: Props) {
  const { currentUser, isAdvisor } = useCurrentUser();
  const [transferOpen, setTransferOpen] = useState(false);

  const canTransfer = currentUser != null && !isAdvisor;

  return (
    <Box ta="right">
      <Menu position="bottom-end" withinPortal>
        <Menu.Target>
          <ActionIcon variant="subtle" color="gray">
            <IconDotsVertical size={iconSize} color={iconColor} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item leftSection={<IconEdit size={14} />} onClick={onEdit}>
            Edit family
          </Menu.Item>
          {canTransfer && (
            <Menu.Item
              leftSection={<IconUserShare size={14} />}
              onClick={() => setTransferOpen(true)}
            >
              Transfer
            </Menu.Item>
          )}
          <Menu.Item leftSection={<IconTrash size={14} />} color="red" onClick={onDelete}>
            Delete family
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
      {transferOpen && (
        <TransferFamilyModal
          familyId={family.id}
          currentAdvisorId={family.advisorUserId}
          opened={true}
          close={() => setTransferOpen(false)}
        />
      )}
    </Box>
  );
}
